import { FontSetting } from "@/models/FontSetting";

export function getCSSForChordSheet(
  fontSize: string,
  fontSettings: {
    headings: FontSetting;
    directions: FontSetting;
    chords: FontSetting;
    lyrics: FontSetting;
  },
  darkMode: boolean,
  forPDF = false,
) {
  const headingColor = AvailableTextColors.find(
    (c) => c.name === fontSettings.headings.color,
  );
  const chordColor = AvailableTextColors.find(
    (c) => c.name === fontSettings.chords.color,
  );
  const lyricsColor = AvailableTextColors.find(
    (c) => c.name === fontSettings.lyrics.color,
  );
  const directionsColor = AvailableTextColors.find(
    (c) => c.name === fontSettings.directions.color,
  );

  const headingHighlight = AvailableHighlightColors.find(
    (c) => c.name === fontSettings.headings.highlight,
  );
  const chordHighlight = AvailableHighlightColors.find(
    (c) => c.name === fontSettings.chords.highlight,
  );
  const lyricsHighlight = AvailableHighlightColors.find(
    (c) => c.name === fontSettings.lyrics.highlight,
  );
  const directionsHighlight = AvailableHighlightColors.find(
    (c) => c.name === fontSettings.directions.highlight,
  );

  const headingsFamily = AvailableFontFamilies.find(
    (f) => f.type === fontSettings.headings.family,
  )?.fontFamilyName;
  const lyricsFamily = AvailableFontFamilies.find(
    (f) => f.type === fontSettings.lyrics.family,
  )?.fontFamilyName;
  const directionsFamily = AvailableFontFamilies.find(
    (f) => f.type === fontSettings.directions.family,
  )?.fontFamilyName;
  const chordsFamily = AvailableFontFamilies.find(
    (f) => f.type === fontSettings.chords.family,
  )?.fontFamilyName;

  let headingColorCss = headingColor?.light;
  let chordColorCss = chordColor?.light;
  let lyricsColorCss = lyricsColor?.light;
  let directionsColorCss = directionsColor?.light;

  let headingHighlightCss = headingHighlight?.light;
  let chordHighlightCss = chordHighlight?.light;
  let lyricsHighlightCss = lyricsHighlight?.light;
  let directionsHighlightCss = directionsHighlight?.light;

  if (darkMode) {
    headingColorCss = headingColor?.dark;
    chordColorCss = chordColor?.dark;
    lyricsColorCss = lyricsColor?.dark;
    directionsColorCss = directionsColor?.dark;

    headingHighlightCss = headingHighlight?.dark;
    chordHighlightCss = chordHighlight?.dark;
    lyricsHighlightCss = lyricsHighlight?.dark;
    directionsHighlightCss = directionsHighlight?.dark;
  }

  let importFonts = "";
  if (forPDF) {
    const urls = [] as string[];

    const headingsFont = AvailableFontFamilies.find(
      (f) => f.type === fontSettings.headings.family,
    );
    const lyricsFont = AvailableFontFamilies.find(
      (f) => f.type === fontSettings.lyrics.family,
    );
    const directionsFont = AvailableFontFamilies.find(
      (f) => f.type === fontSettings.directions.family,
    );
    const chordsFont = AvailableFontFamilies.find(
      (f) => f.type === fontSettings.chords.family,
    );

    if (headingsFont && !urls.includes(headingsFont.url)) {
      urls.push(headingsFont.url);
    }
    if (lyricsFont && !urls.includes(lyricsFont.url)) {
      urls.push(lyricsFont.url);
    }
    if (directionsFont && !urls.includes(directionsFont.url)) {
      urls.push(directionsFont.url);
    }
    if (chordsFont && !urls.includes(chordsFont.url)) {
      urls.push(chordsFont.url);
    }

    urls.forEach((url) => {
      importFonts += `@import url('${url}');\n`;
    });
  }

  const fontSizeString = forPDF
    ? `
          body{
            font-size: ${(parseInt(fontSize) / 16).toFixed(3)}em;
          }
      `
    : "";

  return `<style>
      ${importFonts}
      ${fontSizeString}

      .cproComment{
        font-size: ${(parseInt(fontSettings.headings.size) / 16).toFixed(
          3,
        )}em !important;
        color:${headingColorCss} !important;
        background-color: ${headingHighlightCss} !important;
        font-family: ${headingsFamily} !important;
      }
      
      .cproSongLine{
        font-size: ${(parseInt(fontSettings.lyrics.size) / 16).toFixed(
          3,
        )}em !important;
        color: ${lyricsColorCss} !important;
        background-color: ${lyricsHighlightCss} !important;
        font-family: ${lyricsFamily} !important;
      }
      .chord{
        font-size: ${(
          parseInt(fontSettings.chords.size) /
          16 /
          (parseInt(fontSettings.lyrics.size) / 16)
        ).toFixed(3)}em !important;
        color: ${chordColorCss} !important;
        line-height: 1em;
        background-color: ${chordHighlightCss} !important;
        font-family: ${chordsFamily} !important;
      }
      .cproDirection{
        font-size: ${(
          parseInt(fontSettings.directions.size) /
          16 /
          (parseInt(fontSettings.lyrics.size) / 16)
        ).toFixed(3)}em !important;
        color: ${directionsColorCss} !important;
        background-color: ${directionsHighlightCss} !important;
        font-family: ${directionsFamily} !important;
      }
      </style>`;
}
